import { BuildHtml } from "~/components/BuildHtml";
import { TagToClassNameMap } from "~/lib/shared/html-utils";

const tagToClassNameMap: TagToClassNameMap = new Map([
  ["p", "mb-m last:mb-0 text-body-large"],
  ["h1", "mb-m"],
  ["h2", "mb-m"],
  ["h3", "mb-m"],
  ["h4", "mb-m"],
  ["ul", "mb-m ml-m text-body-large"],
  ["ol", "mb-m ml-m"],
  ["li", "list-disc list-outside mb-s last:mb-0"],
  [
    "a",
    "underline text-primary hover:text-primary-900 visited:text-primary-900",
  ],
]);

export type ArticleContentBlockProps = {
  contentHTML: string;
};

export const ArticleContentBlock = ({
  contentHTML,
}: ArticleContentBlockProps) => (
  <BuildHtml html={contentHTML} tagToClassNameMap={tagToClassNameMap} />
);
